import React from "react";
// import logo from "./logo.svg";
import "./App.css";
import Map from "./modules/Map";
import { useDispatch } from "react-redux";
import { baseUrlSetter } from "./config/config";
import { provinceFetch } from "./modules/Body/api/redux";
import Routes from "./Routes";

function App() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    fetch("const.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        return await response.json();
      })
      .then(async (myJson) => {
        document.title = myJson.title;
        dispatch(provinceFetch(myJson.provinceId));
      });
  });

  return <Routes />;
}

export default App;
